import React from "react";
import { useI18n } from "../../i18n";
import { useSettings } from "../../contexts/SettingsContext";

// Sanitize: keep digits only (E.164 expects digits-only after +)
const cleanPhone = (raw) => (raw || "").replace(/[^\d]/g, "");

const WhatsAppButton = () => {
  const { lang } = useI18n();
  const { settings } = useSettings();
  const social = settings?.social || {};
  const phone = cleanPhone(social.whatsapp_number);
  if (!phone) return null; // hide button when admin hasn't set a number

  const defaultMsg = lang === "nl" ? "Hallo SnapShop, ik heb een vraag." : "Hello SnapShop, I have a question.";
  const customMsg = lang === "nl" ? social.whatsapp_message_nl : social.whatsapp_message_en;
  const msg = encodeURIComponent(customMsg || defaultMsg);
  const href = `https://wa.me/${phone}?text=${msg}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      aria-label="WhatsApp"
      className="fixed z-30 bottom-5 left-5 md:bottom-8 md:left-8 w-12 h-12 md:w-14 md:h-14 bg-[#25D366] hover:bg-[#1faa54] flex items-center justify-center shadow-[0_18px_40px_-12px_rgba(37,211,102,0.6)] rounded-full transition-colors group"
    >
      <svg viewBox="0 0 24 24" className="w-6 h-6 md:w-7 md:h-7 text-white" fill="currentColor">
        <path d="M20.52 3.48A11.815 11.815 0 0 0 12 .002C5.371.002 0 5.373 0 12c0 2.115.553 4.18 1.602 6L0 24l6.18-1.621A11.997 11.997 0 0 0 12 24c6.629 0 12-5.371 12-11.998 0-3.205-1.248-6.213-3.48-8.522ZM12 21.838c-1.851 0-3.659-.5-5.243-1.443l-.376-.224-3.671.963.98-3.578-.244-.367a9.815 9.815 0 0 1-1.512-5.19c0-5.43 4.42-9.852 9.852-9.852A9.808 9.808 0 0 1 21.84 12c0 5.433-4.42 9.838-9.84 9.838Zm5.47-7.385c-.299-.149-1.77-.873-2.044-.972-.275-.099-.475-.149-.674.149-.198.299-.773.972-.948 1.171-.174.199-.349.224-.648.075-.299-.149-1.262-.465-2.404-1.483-.889-.793-1.488-1.772-1.663-2.071-.174-.299-.018-.46.131-.609.134-.133.299-.349.448-.523.149-.174.198-.298.298-.498.099-.198.05-.373-.025-.523-.075-.149-.674-1.624-.923-2.224-.242-.583-.488-.503-.674-.512-.174-.008-.373-.01-.572-.01-.198 0-.523.075-.797.373-.275.298-1.045 1.02-1.045 2.487 0 1.466 1.07 2.882 1.22 3.082.149.198 2.105 3.213 5.099 4.504.713.308 1.269.491 1.703.629.715.227 1.366.195 1.881.118.574-.086 1.77-.723 2.02-1.422.249-.7.249-1.301.174-1.422-.075-.124-.275-.198-.574-.347Z"/>
      </svg>
      <span className="absolute right-full mr-3 whitespace-nowrap bg-ink text-white text-xs px-3 py-1.5 opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity hidden md:block">
        {lang === "nl" ? "Chat met ons op WhatsApp" : "Chat with us on WhatsApp"}
      </span>
    </a>
  );
};

export default WhatsAppButton;
